import { render, staticRenderFns } from "./LeaveReport.vue?vue&type=template&id=6579c194&"
import script from "./LeaveReport.vue?vue&type=script&lang=js&"
export * from "./LeaveReport.vue?vue&type=script&lang=js&"
import style0 from "./LeaveReport.vue?vue&type=style&index=0&id=6579c194&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports